exports.loader = (context, ref, options) => {
  let loader = context.$loading.show({
    container: ref,
    loader: (options ? options.loaderType : "spinner"),
    color: (options && typeof options.color !== 'undefined' ? options.color : '#000'),
    width: 30,
    height: 30,
    zIndex: (options && typeof options.zIndex !== 'undefined' ? options.zIndex : 20),
    opacity: ( options && typeof options.opacity !== 'undefined' ? options.opacity : 0.7),
    backgroundColor: (options && typeof options.backgroundColor !== 'undefined' ? options.backgroundColor : '#fff')
  });
  // console.log("loader", loader)
  return loader;
};
